import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as Request from "../../entries/common/request";
import { BaseApi } from "../../core/base-api";
import { makeMethod } from "../../core/base-api/methods-maker";
export var UsersPlaylistsApi = /*#__PURE__*/function (_BaseApi) {
  _inherits(UsersPlaylistsApi, _BaseApi);

  var _super = _createSuper(UsersPlaylistsApi);

  function UsersPlaylistsApi() {
    _classCallCheck(this, UsersPlaylistsApi);

    return _super.apply(this, arguments);
  }

  return UsersPlaylistsApi;
}(BaseApi);
/**
 * get list of a user's playlists
 */

UsersPlaylistsApi.prototype.list = makeMethod({
  method: 'get',
  path: Request.Users.Playlists.Paths.List,
  needAuth: true
});
/**
 * get playlist info
 */

UsersPlaylistsApi.prototype.show = makeMethod({
  method: 'get',
  path: Request.Users.Playlists.Paths.Show,
  needAuth: true
});
/**
 * get videos for playlist
 */

UsersPlaylistsApi.prototype.listVideos = makeMethod({
  method: 'get',
  path: Request.Users.Playlists.Paths.ListVideos,
  needAuth: true
});
/**
 * get videos for playlist
 */

UsersPlaylistsApi.prototype.findVideoIndex = makeMethod({
  method: 'get',
  path: Request.Users.Playlists.Paths.FindVideoIndex,
  needAuth: true
});